import axios from 'axios';
import { StrawStageApiResponse } from '../../common/model/dto/straw-stage/straw-stage-api-response';
import { ADMIN_STRAW_STAGE_ROUTE } from '../../api/backend';

export const getReproductiveStageForUser = async (userId: string) => {
  const { data } = await axios.get<StrawStageApiResponse>(
    `${ADMIN_STRAW_STAGE_ROUTE}/users/${userId}`
  );

  return data;
};
